import React from "react";
import styled from "styled-components";
import IconButton from "@material-ui/core/IconButton";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

import BigTooltip from "./BigTooltip";

const InlineIconButton = styled(IconButton)`
    padding: 0;
    margin-right: 0;
    color: #5f6368;

    &::-moz-focus-inner {
        border: 0;
    }

    &:focus {
        outline: none !important;
    }

    &:focus-visible {
        outline: none !important;
        box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.28);
        border-radius: 50%;
    }
`;

export default function InfoTooltip({ text }) {
    if (!text) return null;
    return (
        <BigTooltip title={text} placement="top" arrow enterTouchDelay={50}>
            <InlineIconButton size="small" aria-label="information">
                <InfoOutlinedIcon fontSize="small" />
            </InlineIconButton>
        </BigTooltip>
    );
}
